import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/schemas';
import MentoringProgramContext from 'athena/components/mentoring-program/context';
import { getMentoringProgramEnrollment } from 'redux/selectors/mentoring-program-enrollments';
import { AdminBitValue, MenteeBitValue, MentorBitValue, MentoringProgramPermissionBitValue } from 'redux/schemas/models/mentoring-program-enrollments';


const useMentoringProgramRole = () => {
  const { mentoringProgram } = useContext(MentoringProgramContext);
  const { mentorshipProgramEnrollment: enrollmentId } = mentoringProgram || {};
  const { role } = useSelector(
    (state: RootState) => getMentoringProgramEnrollment(state, enrollmentId),
  ) || {};

  const hasPermission = (
    bitField: MentoringProgramPermissionBitValue,
    permissionType: MentoringProgramPermissionBitValue,
  ) => {
    if (mentoringProgram && bitField) {
      // eslint-disable-next-line no-bitwise
      return (bitField & permissionType) > 0;
    }

    return null;
  };

  const isAdmin = hasPermission(role?.permission, AdminBitValue);
  const isMentor = hasPermission(role?.permission, MentorBitValue);
  const isMentee = hasPermission(role?.permission, MenteeBitValue);

  return {
    isAdmin,
    isMentor,
    isMentee,
  };
};

export default useMentoringProgramRole;
